import { PeopleBadgeList } from '@/routes/_layout/scheduling/student-groups/-components/people-badge-list';
import { getSessionSubstitutionRequestSummary } from '@airreading/common';
import {
  AdminSession,
  SubstitutionRequestStatus,
  VideoConferenceType,
  SubstitutionRequestOrigin,
} from '@airreading/common/data';

interface OriginalTeacherDisplayProps {
  session: AdminSession;
}

export const OriginalTeacherDisplay = ({ session }: OriginalTeacherDisplayProps) => {
  const { mostRecentRequest } = getSessionSubstitutionRequestSummary(session);
  const hasPendingRequest = mostRecentRequest?.status === SubstitutionRequestStatus.pending;
  const isAutomaticConflict = mostRecentRequest?.origin === SubstitutionRequestOrigin.automatic_conflict;
  const isZoom = session.videoConferenceType === VideoConferenceType.zoom;
  const { coach } = session;

  if (isZoom && hasPendingRequest && isAutomaticConflict) {
    return 'Pending substitute teacher';
  }
  return coach ? <PeopleBadgeList people={[coach]} /> : null;
};
